import { render, staticRenderFns } from "./creatOrder.vue?vue&type=template&id=15c9fed5&scoped=true&"
import script from "./creatOrder.vue?vue&type=script&lang=js&"
export * from "./creatOrder.vue?vue&type=script&lang=js&"
import style0 from "./creatOrder.vue?vue&type=style&index=0&id=15c9fed5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c9fed5",
  null
  
)

export default component.exports